import React from 'react';
import { createStyles, withStyles, WithStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import { useFlags } from 'launchdarkly-react-client-sdk';

import { getCurrentUser } from '../../../../../selectors/userSelectors';
import { colors } from '../../../../../themes/colors';

type Props = WithStyles<typeof styles>;

const SessionsListHeader: React.FC<Props> = ({ classes }) => {
  const currentUser = useSelector(getCurrentUser);
  const { showHpiClientStatusInfo } = useFlags();
  const providerIsPsychiatrist = currentUser.isPsychiatrist;

  const headerClassName = classNames(classes.sessionsListHeader, {
    [classes.sessionsListHeaderWithSessionType]: showHpiClientStatusInfo,
  });

  return (
    <div className={headerClassName}>
      <div className={`${classes.sessionTime} ${classes.headerItem}`}>Your Time</div>

      <div className={`${classes.sessionTime} ${classes.headerItem}`}>Member's Time</div>

      <div className={`${classes.sessionState} ${classes.headerItem}`}>Status</div>

      <div className={`${classes.memberName} ${classes.headerItem}`}>Client</div>

      {(showHpiClientStatusInfo || providerIsPsychiatrist) && (
        <div className={classes.headerItem}>Session Type</div>
      )}

      <div className={`${classes.company} ${classes.headerItem}`}>Company</div>

      <div className={`${classes.actions} ${classes.headerItem}`}>Actions</div>
    </div>
  );
};

const styles = () =>
  createStyles({
    actions: {
      padding: '0 10px 0 20px',
    },
    company: {
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'row',
    },
    headerItem: {
      color: colors.black4,
      fontSize: 14,
      fontWeight: 600,
    },
    memberName: {
      alignItems: 'center',
      color: colors.black4,
      display: 'flex',
      flexDirection: 'row',
      fontSize: 14,
      fontWeight: 600,
      minWidth: 150,
    },
    sessionsListHeader: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr 3fr',
      marginTop: 25,
    },
    sessionsListHeaderWithSessionType: {
      gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr 1fr 3fr',
    },
    sessionState: {
      width: 200,
    },
    sessionTime: {
      color: colors.black4,
      fontSize: 14,
      width: 200,
    },
  });

export default withStyles(styles)(SessionsListHeader);
